import { type AnyAction } from 'redux';
import { SET_COMMUNITIES_CONTEXT } from './communities-context-actions';

type State = Record<string, any>;

export function communitiesContext(state: State = {}, action: AnyAction): State {
  switch (action.type) {
    case SET_COMMUNITIES_CONTEXT:
      return action.payload;
    default:
      return state;
  }
}
